import { Component, Input } from '@angular/core';

import { of, catchError, tap, finalize } from 'rxjs';

import { RecurlySubscription } from '@shared/recurly/models';
import { SubscriptionService } from '../../services';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AlertsService, IAlertTypes } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'pause-or-cancel-subscription',
  templateUrl: './reactivate-subscription.component.html',
})
export class ReactivateSubscriptionComponent {
  @Input() sub?: RecurlySubscription;
  @Input() onClose?: () => void;

  inProgress = false;

  constructor(
    readonly modalController: FrontendModalService,
    private readonly alertsService: AlertsService,
    private readonly subscriptionService: SubscriptionService,
  ) { }

  cancel(): void {
    this.modalController.dismiss();
  }

  reactivate(): void {
    this.subscriptionService.reactivate({ uuid: this.sub.uuid })
      .pipe(
        tap(() => {
          this.alertsService.add({
            type: IAlertTypes.success,
            heading: 'Success:',
            body: 'subscription reactivated successfully.',
          });
          this.modalController.dismiss();
        }),
        catchError((error) => {
          this.alertsService.add({
            type: IAlertTypes.danger,
            heading: 'Error:',
            body: String(error),
          });
          this.modalController.dismiss();

          return of(error);
        }),
        finalize(() => {
          if (typeof this.onClose === 'function') {
            this.onClose();
          }
        }),
      )
      .subscribe();
  }
}
